import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import * as T from "./type";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import { getSaga } from "src/request/get";
import { putSaga } from "src/request/put";
import { postSaga } from "src/request/post";
import { deleteSaga } from "src/request/delete";

/*DELIVERY_REFUND DEFINITION*/
export const getPicklistDeliveryRefundDefinition = createAction(
  "GET_PICKLIST_DELIVERY_REFUND_DEFINITION",
  ({ payload, params }: SagaActionParams<T.DeliveryRefundDefinitionDto[]>) => ({
    payload,
    url:
      "/api/admin/admindeliveryrefunddefinition/picklist" +
      (params ? params : ""),
  })
);
export const getDeliveryRefundDefinitions = createAction(
  "GET_DELIVERY_REFUND_DEFINITIONS",
  ({ payload, params }: SagaActionParams<T.DeliveryRefundDefinitionDto[]>) => ({
    payload,
    url: "/api/admin/admindeliveryrefunddefinition" + (params ? params : ""),
  })
);
export const getDeliveryRefundDefinitionDetails = createAction(
  "GET_DELIVERY_REFUND_DEFINITION_DETAILS",
  ({ payload, id }: SagaActionParams<T.DeliveryRefundDefinitionDetailDto>) => ({
    payload,
    url: "/api/admin/admindeliveryrefunddefinition/" + id,
  })
);
export const createDeliveryRefundDefinition = createAction(
  "CREATE_DELIVERY_REFUND_DEFINITION",
  ({ payload, body }: SagaActionParams<T.DeliveryRefundDefinitionDto>) => ({
    payload,
    url: "/api/admin/admindeliveryrefunddefinition",
    body,
  })
);
export const updateDeliveryRefundDefinition = createAction(
  "UPDATE_DELIVERY_REFUND_DEFINITION",
  ({ payload, id, body }: SagaActionParams<T.DeliveryRefundDefinitionDto>) => ({
    payload,
    url: "/api/admin/admindeliveryrefunddefinition/" + id,
    body,
  })
);
export const deleteDeliveryRefundDefinition = createAction(
  "DELETE_DELIVERY_REFUND_DEFINITION",
  ({ payload, id }: SagaActionParams<T.DeliveryRefundDefinitionDto>) => ({
    payload,
    url: "/api/admin/admindeliveryrefunddefinition/" + id,
  })
);

//DELIVERY_REFUND_DEFINITION PICKLIST OPTIONS
export const getPicklistOptionsDeliveryRefundDefinitionId = createAction(
  "GET_DELIVERY_REFUND_DEFINITION_OPTIONS_BY_DEFINITIONID",
  ({
    payload,
    params,
    id,
  }: SagaActionParams<T.DeliveryRefundDefinitionPicklistOptionDto[]>) => ({
    payload,
    url:
      "/api/admin/admindeliveryrefunddefinitionpicklistoptions/getbydefinitionid/" +
      id +
      (params ? params : ""),
  })
);
export const getDeliveryRefundDefinitionPicklistOptionDetail = createAction(
  "GET_DELIVERY_REFUND_DEFINITION_OPTION_DETAILS",
  ({
    payload,
    id,
  }: SagaActionParams<T.DeliveryRefundDefinitionPicklistOptionDto>) => ({
    payload,
    url: "/api/admin/admindeliveryrefunddefinitionpicklistoptions/" + id,
  })
);
export const addDeliveryRefundDefinitionPicklistOption = createAction(
  "ADD_DELIVERY_REFUND_DEFINITION_OPTIONS",
  ({
    payload,
    body,
  }: SagaActionParams<T.DeliveryRefundDefinitionPicklistOptionDto>) => ({
    payload,
    body: body,
    url: "/api/admin/admindeliveryrefunddefinitionpicklistoptions",
  })
);
export const updateDeliveryRefundDefinitionPicklistOption = createAction(
  "UPDATE_DELIVERY_REFUND_DEFINITION_OPTIONS",
  ({
    payload,
    id,
    body,
  }: SagaActionParams<T.DeliveryRefundDefinitionPicklistOptionDto>) => ({
    payload,
    body: body,
    url: "/api/admin/admindeliveryrefunddefinitionpicklistoptions/" + id,
  })
);
export const deleteDeliveryRefundDefinitionPicklistOption = createAction(
  "DELETE_DELIVERY_REFUND_DEFINITION_OPTIONS",
  ({
    payload,
    id,
  }: SagaActionParams<T.DeliveryRefundDefinitionPicklistOptionDto>) => ({
    payload,
    url: "/api/admin/admindeliveryrefunddefinitionpicklistoptions/" + id,
  })
);

const pickupDefinitionSaga = [
  //DELIVERY REFUND DEFINITIONS

  takeLatest<any>(
    getDeliveryRefundDefinitions.toString(),
    (payload: SagaGenericParams<T.DeliveryRefundDefinitionDto[]>) =>
      getSaga<T.DeliveryRefundDefinitionDto[]>(payload)
  ),
  takeLatest<any>(
    getDeliveryRefundDefinitionDetails.toString(),
    (payload: SagaGenericParams<T.DeliveryRefundDefinitionDto>) =>
      getSaga<T.DeliveryRefundDefinitionDto>(payload)
  ),
  takeLatest<any>(
    createDeliveryRefundDefinition.toString(),
    (payload: SagaGenericParams<T.DeliveryRefundDefinitionDto>) =>
      postSaga<T.DeliveryRefundDefinitionDto>(payload)
  ),
  takeLatest<any>(
    updateDeliveryRefundDefinition.toString(),
    (payload: SagaGenericParams<T.DeliveryRefundDefinitionDto>) =>
      putSaga<T.DeliveryRefundDefinitionDto>(payload)
  ),
  takeLatest<any>(
    deleteDeliveryRefundDefinition.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<T.DeliveryRefundDefinitionDto>(payload)
  ),
  //DELIVERY_REFUND_DEFINITION PICKLIST OPTIONS
  takeLatest<any>(
    getPicklistDeliveryRefundDefinition.toString(),
    (payload: SagaGenericParams<T.DeliveryRefundDefinitionDto[]>) =>
      getSaga<T.DeliveryRefundDefinitionDto[]>(payload)
  ),
  takeLatest<any>(
    getPicklistOptionsDeliveryRefundDefinitionId.toString(),
    (
      payload: SagaGenericParams<T.DeliveryRefundDefinitionPicklistOptionDto[]>
    ) => getSaga<T.DeliveryRefundDefinitionPicklistOptionDto[]>(payload)
  ),
  takeLatest<any>(
    getDeliveryRefundDefinitionPicklistOptionDetail.toString(),
    (
      payload: SagaGenericParams<T.DeliveryRefundDefinitionPicklistOptionDto[]>
    ) => getSaga<T.DeliveryRefundDefinitionPicklistOptionDto[]>(payload)
  ),
  takeLatest<any>(
    getDeliveryRefundDefinitionPicklistOptionDetail.toString(),
    (payload: SagaGenericParams<T.DeliveryRefundDefinitionPicklistOptionDto>) =>
      getSaga<T.DeliveryRefundDefinitionPicklistOptionDto>(payload)
  ),
  takeLatest<any>(
    addDeliveryRefundDefinitionPicklistOption.toString(),
    (payload: SagaGenericParams<T.DeliveryRefundDefinitionPicklistOptionDto>) =>
      postSaga<T.DeliveryRefundDefinitionPicklistOptionDto>(payload)
  ),
  takeLatest<any>(
    updateDeliveryRefundDefinitionPicklistOption.toString(),
    (payload: SagaGenericParams<T.DeliveryRefundDefinitionPicklistOptionDto>) =>
      putSaga<T.DeliveryRefundDefinitionPicklistOptionDto>(payload)
  ),
  takeLatest<any>(
    deleteDeliveryRefundDefinitionPicklistOption.toString(),
    (payload: SagaGenericParams<T.DeliveryRefundDefinitionPicklistOptionDto>) =>
      deleteSaga<T.DeliveryRefundDefinitionPicklistOptionDto>(payload)
  ),
];

export default pickupDefinitionSaga;
